import alerts from 'Core/ducks/alerts';
import legalAcceptance from 'Core/ducks/legalAcceptance';
import legalDocument from 'Core/ducks/legalDocument';
import modal from 'Core/ducks/modal';
import search from 'Core/ducks/search';
import snackbar from 'Core/ducks/snackbar';
import breadcrumbs from 'Core/ducks/breadcrumbs';
import footer from 'Core/ducks/footer';
import featureToggle from 'Core/ducks/featureToggle';
import featureFlag from 'Core/ducks/featureFlag';
import refreshToken from 'Core/ducks/refreshToken';
import login from "./login";
import schoox from "./schoox";
import analytics from 'Core/ducks/analytics';
import dashboardTaxYears from 'Core/ducks/taxYears';

export default {
  snackbar,
  breadcrumbs,
  alerts,
  modal,
  legalAcceptance,
  search,
  legalDocument,
  footer,
  featureToggle,
  featureFlag,
  refreshToken,
  login,
  schoox,
  analytics,
  dashboardTaxYears,
};
